/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './create-team-member';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "team_api": {
        "nested": {
          "BulkCreateTeamMembersRequest": {
            "fields": {
              "teamMembers": {
                "type": ".squareup.team_api.CreateTeamMemberRequest",
                "id": 1,
                "keyType": "string"
              }
            }
          },
          "BulkCreateTeamMembersResponse": {
            "fields": {
              "teamMembers": {
                "type": ".squareup.team_api.CreateTeamMemberResponse",
                "id": 1,
                "keyType": "string"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.team_api?.nested?.BulkCreateTeamMembersRequest && !$root.nested?.squareup?.nested?.team_api?.nested?.BulkCreateTeamMembersResponse) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents a bulk create request for `TeamMember` objects.
 * --
 *
 * SOURCE BulkCreateTeamMembersRequest @ squareup/team_api/endpoints/bulk-create-team-members.proto at 23:1
 */
export const BulkCreateTeamMembersRequest = $root.lookupType('squareup.team_api.BulkCreateTeamMembersRequest');
fixType(BulkCreateTeamMembersRequest, {
  teamMembers: {
    required: true
  }
});
Builder.createAndAttachToType(BulkCreateTeamMembersRequest);
/**
 * --
 * @desc Represents a response from a bulk create request containing the created `TeamMember` objects or error messages.
 * --
 *
 * SOURCE BulkCreateTeamMembersResponse @ squareup/team_api/endpoints/bulk-create-team-members.proto at 40:1
 */
export const BulkCreateTeamMembersResponse = $root.lookupType('squareup.team_api.BulkCreateTeamMembersResponse');
fixType(BulkCreateTeamMembersResponse);
Builder.createAndAttachToType(BulkCreateTeamMembersResponse);